import { getFileURL } from '@/features/files/api'
import { convertFileToBlobAndDownload } from '@/utils/client/download-file'

const PREVIEWABLE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'bmp',
  'pdf',
  'mp4',
  'webm',
  'ogg',
  'mov',
  'avi',
]

function getFileExtension(fileName: string): string {
  return fileName.split('.').pop()?.toLowerCase() || ''
}

// telecharge le fichier, meme s'il est lisible par le navigateur
export async function downloadChatFile(file: { id: string; name: string }, ownerId: string) {
  try {
    const response = await getFileURL({ fileId: file.id, userId: ownerId })
    await convertFileToBlobAndDownload(response.url, file.name)
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}

// ouvre les fichiers lisibles par le navigateur dans un onglet, telecharge les autres
export async function openChatFile(file: { id: string; name: string }, ownerId: string) {
  try {
    const response = await getFileURL({ fileId: file.id, userId: ownerId })
    if (PREVIEWABLE_EXTENSIONS.includes(getFileExtension(file.name))) {
      window.open(response.url, '_blank', 'noopener,noreferrer')
    } else {
      await convertFileToBlobAndDownload(response.url, file.name)
    }
  } catch (error) {
    console.error('Error handling file:', error)
  }
}
